import queryString from 'query-string';

import { Box } from 'components/Box';
import { AnchorButton } from 'components/Button/AnchorButton';
import { TileCarouselHeader } from 'components/TileCarousel';
import { JobFunction } from 'utils/constants';
import { listingSearchHomePath } from 'utils/searchHomePages';

import { CmsAmpRecommendedJobCard } from './CmsAmpRecommendedJobCard';

type AmpCmsRecommendedJobsProps = {
  headline: string;
  layout: 'SLIM' | 'REGULAR';
  source: 'RECOMMENDED_JOBS_CHECKBOX' | 'RECOMMENDED_JOBS_BLOCK';
  jobFunction: JobFunction | null | undefined;
};

export function CmsAmpRecommendedJobs({
  headline,
  layout,
  jobFunction,
  source,
}: AmpCmsRecommendedJobsProps) {
  return (
    <>
      <TileCarouselHeader
        layout={layout}
        // @ts-expect-error ts-migrate(2322) FIXME: Type '{ layout: "SLIM" | "REGULAR"; source: "RECOM... Remove this comment to see the full error message
        source={source}
        headline={headline}
        linkNode={
          <AnchorButton
            href={`${listingSearchHomePath('JOB')}?${queryString.stringify(
              {
                searchMode: true,
                q: '',
                functions: [jobFunction],
              },
              {
                skipNull: true,
              }
            )}`}
          >
            {getText('See All')}
          </AnchorButton>
        }
      />

      <Box mt={48}>
        <amp-list
          width="auto"
          height="200"
          layout="fixed-height"
          src={`/data/website/search/latest-jobs${
            !jobFunction
              ? ''
              : queryString.stringify({
                  functions: [jobFunction],
                })
          }`}
          items="results"
          max-items="3"
        >
          <template type="amp-mustache">
            <CmsAmpRecommendedJobCard layout={layout} />
          </template>
        </amp-list>
      </Box>
    </>
  );
}
